<template>
  <vue-tabs v-if="tabs" @tab-change="emitChange">
    <template v-for="(item, i) in tabs">
      <v-tab :key="i" :title="item.label">
        <slot :name="item.name">{{ item.content }}</slot>
      </v-tab>
    </template>
  </vue-tabs>
</template>
<script>
import "vue-nav-tabs/themes/vue-tabs.css";
import { VTab, VueTabs } from "vue-nav-tabs";
export default {
  name: "Tab",
  components: {
    VueTabs,
    VTab,
  },
  props: {
    tabs: Array,
  },
  setup(props, { emit }) {
    const emitChange = (tabIndex, newTab, oldTab) =>
      emit("tabChanged", tabIndex, newTab.title, oldTab.title);

    return { emitChange };
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";

.vue-tabs .nav-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  padding-left: 20px;
  font-family: "Muli", sans-serif;
  font-size: 0.875rem;
}

.vue-tabs .nav-tabs > li > a,
.vue-tabs .nav-tabs > li > a:hover,
.vue-tabs .nav-tabs > li > a:focus {
  border: none;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-radius: 0;
}

.vue-tabs .nav-tabs > li.active > a,
.vue-tabs .nav-tabs > li.active > a:hover,
.vue-tabs .nav-tabs > li.active > a:focus {
  border: none;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-radius: 0;
  font-size: 14px;
  font-weight: 600;
}

.tab-content {
  margin-top: 30px;
}
</style>
